export default "__VITE_ASSET__C5$ZYHlF__"